import { Field, Entity } from "typegraph";

@Entity({ update: "topicVoteNegative" })
export default class TopicDownvote {
	@Field()
	message: string; // the topic vote message
}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/TopicDownvote.ts